import apiService from './api';
class SettingsService {
    // Obter configurações da empresa
    async getEmpresaSettings() {
        const response = await apiService.get('/configuracoes/empresa');
        return response.data;
    }
    // Atualizar configurações da empresa
    async updateEmpresaSettings(settings) {
        const response = await apiService.put('/configuracoes/empresa', settings);
        return response.data;
    }
    // Obter configurações do sistema
    async getSystemSettings() {
        const response = await apiService.get('/configuracoes/sistema');
        return response.data;
    }
    // Atualizar configurações do sistema
    async updateSystemSettings(settings) {
        const response = await apiService.put('/configuracoes/sistema', settings);
        return response.data;
    }
    // Criar backup
    async createBackup() {
        const response = await apiService.post('/configuracoes/backup');
        return response.data;
    }
    // Resetar configurações
    async resetToDefaults() {
        const response = await apiService.post('/configuracoes/reset');
        return response.data;
    }
    // Obter opções de configuração
    async getConfigOptions() {
        // Mock data for now - should be implemented in backend
        return {
            distritos: [
                'Aveiro', 'Beja', 'Braga', 'Bragança', 'Castelo Branco',
                'Coimbra', 'Évora', 'Faro', 'Guarda', 'Leiria', 'Lisboa',
                'Portalegre', 'Porto', 'Santarém', 'Setúbal', 'Viana do Castelo',
                'Vila Real', 'Viseu', 'Açores', 'Madeira'
            ],
            regimesIva: [
                { value: 'NORMAL', label: 'Regime Normal' },
                { value: 'ISENCAO', label: 'Isento de IVA' },
                { value: 'SIMPLIFICADO', label: 'Regime Simplificado' }
            ],
            moedas: [
                { value: 'EUR', label: 'Euro (€)' },
                { value: 'USD', label: 'Dólar Americano ($)' },
                { value: 'GBP', label: 'Libra Esterlina (£)' }
            ],
            idiomas: [
                { value: 'pt-PT', label: 'Português (Portugal)' },
                { value: 'pt-BR', label: 'Português (Brasil)' },
                { value: 'en-US', label: 'English (US)' },
                { value: 'es-ES', label: 'Español (España)' },
                { value: 'fr-FR', label: 'Français (France)' }
            ],
            timezones: [
                { value: 'Europe/Lisbon', label: 'Europa/Lisboa (GMT+0/+1)' },
                { value: 'Europe/Madrid', label: 'Europa/Madrid (GMT+1/+2)' },
                { value: 'Europe/London', label: 'Europa/Londres (GMT+0/+1)' },
                { value: 'America/New_York', label: 'América/Nova York (GMT-5/-4)' }
            ],
            formatosData: [
                { value: 'DD/MM/YYYY', label: 'DD/MM/AAAA (31/12/2023)' },
                { value: 'MM/DD/YYYY', label: 'MM/DD/AAAA (12/31/2023)' },
                { value: 'YYYY-MM-DD', label: 'AAAA-MM-DD (2023-12-31)' },
                { value: 'DD-MM-YYYY', label: 'DD-MM-AAAA (31-12-2023)' }
            ],
            formatosHora: [
                { value: 'HH:mm', label: '24 horas (23:59)' },
                { value: 'hh:mm A', label: '12 horas (11:59 PM)' },
                { value: 'HH:mm:ss', label: '24 horas com segundos (23:59:59)' }
            ]
        };
    }
    // Obter dados da empresa para templates
    async getEmpresaForTemplates() {
        const response = await apiService.get('/configuracoes/empresa/templates');
        return response.data;
    }
    // Validações locais
    validateNifLocal(nif) {
        if (!nif || typeof nif !== 'string')
            return false;
        const nifLimpo = nif.replace(/\s/g, '');
        if (!/^\d{9}$/.test(nifLimpo))
            return false;
        const primeiroDigito = parseInt(nifLimpo[0]);
        if (![1, 2, 3, 5, 6, 7, 8, 9].includes(primeiroDigito))
            return false;
        const digitos = nifLimpo.split('').map(Number);
        let soma = 0;
        for (let i = 0; i < 8; i++) {
            soma += digitos[i] * (9 - i);
        }
        const resto = soma % 11;
        const digitoControle = resto < 2 ? 0 : 11 - resto;
        return digitoControle === digitos[8];
    }
    validateEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }
    validateCodigoPostal(codigo) {
        const codigoRegex = /^\d{4}-\d{3}$/;
        return codigoRegex.test(codigo);
    }
    validateTelefone(telefone) {
        // Formato português: +351 912 345 678 ou 912 345 678
        const telefoneRegex = /^(\+351\s?)?[29]\d{2}\s?\d{3}\s?\d{3}$/;
        return telefoneRegex.test(telefone.replace(/\s/g, ''));
    }
    validateWebsite(url) {
        try {
            new URL(url);
            return true;
        }
        catch {
            return false;
        }
    }
    // Formatadores
    formatNif(nif) {
        const nifLimpo = nif.replace(/\s/g, '');
        if (nifLimpo.length === 9) {
            return `${nifLimpo.slice(0, 3)} ${nifLimpo.slice(3, 6)} ${nifLimpo.slice(6)}`;
        }
        return nif;
    }
    formatTelefone(telefone) {
        const telefoneLimpo = telefone.replace(/[\s\-\(\)]/g, '');
        if (telefoneLimpo.startsWith('+351')) {
            const numero = telefoneLimpo.slice(4);
            if (numero.length === 9) {
                return `+351 ${numero.slice(0, 3)} ${numero.slice(3, 6)} ${numero.slice(6)}`;
            }
        }
        else if (telefoneLimpo.length === 9) {
            return `${telefoneLimpo.slice(0, 3)} ${telefoneLimpo.slice(3, 6)} ${telefoneLimpo.slice(6)}`;
        }
        return telefone;
    }
    formatCodigoPostal(codigo) {
        const codigoLimpo = codigo.replace(/\D/g, '');
        if (codigoLimpo.length === 7) {
            return `${codigoLimpo.slice(0, 4)}-${codigoLimpo.slice(4)}`;
        }
        return codigo;
    }
    // Obter configurações padrão
    getDefaultEmpresaSettings() {
        return {
            nome: 'NexaMakers OS',
            nif: '',
            atividade: 'Reparação de equipamentos eletrónicos',
            telefone: '',
            email: '',
            morada: '',
            codigoPostal: '',
            cidade: '',
            distrito: 'Lisboa',
            pais: 'Portugal',
            regimeIva: 'NORMAL',
            ivaPercentual: 23,
            horariosAtendimento: {
                segundaASexta: '09:00-18:00'
            },
            tempoGarantia: 6,
            prazoReparacao: 5
        };
    }
    getDefaultSystemSettings() {
        return {
            moeda: 'EUR',
            idioma: 'pt-PT',
            timezone: 'Europe/Lisbon',
            formatoData: 'DD/MM/YYYY',
            formatoHora: 'HH:mm',
            numeracaoOS: {
                prefixo: 'OS',
                tamanho: 6,
                reiniciarAnualmente: true
            },
            numeracaoVenda: {
                prefixo: 'V',
                tamanho: 6,
                reiniciarAnualmente: true
            },
            backupAutomatico: true,
            intervaloBackup: 24,
            manterBackups: 7,
            notificacoesDesktop: true,
            notificacoesSonoras: false,
            sessaoExpira: 480,
            tentativasLogin: 3,
            bloqueioTempo: 15
        };
    }
}
// Instância singleton
const settingsService = new SettingsService();
export default settingsService;
